import React from 'react';

import type { TooltipAnchorProps, TooltipProviderProps } from '@ariakit/react';
import * as Ariakit from '@ariakit/react';
import cn from 'classnames';

import * as styles from './styles.module.css';

export function Provider(props: TooltipProviderProps) {
  return <Ariakit.TooltipProvider timeout={1000} {...props} />;
}

export function Anchor(props: TooltipAnchorProps) {
  return <Ariakit.TooltipAnchor {...props} />;
}

export function Tooltip({
  animated = true,
  className = '',
  ...props
}: { animated?: boolean } & Ariakit.TooltipProps) {
  return (
    <Ariakit.Tooltip
      className={cn(styles.tooltip, animated && styles.animated, className)}
      unmountOnHide
      fixed
      {...props}
    />
  );
}
